 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"page": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"page": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en-js":"lang-en-js","lang-zh-js":"lang-zh-js"}[chunkId]||chunkId) + "." + {"chunk-0c585b89":"b7d45f31","chunk-030f5245":"47c9c1f4","chunk-0d76e780":"feea96a4","chunk-4c058107":"b8c9424a","chunk-4d349a64":"b33e996e","chunk-494d09ee":"838f2834","chunk-2d238065":"6e14228c","chunk-38960fdc":"2f184022","chunk-3ce489d0":"a25ab4ec","chunk-488c6ca2":"5cd3cd2c","chunk-e35cdb6a":"58ae4236","chunk-541fe940":"d991be70","chunk-e8063f78":"ecaba475","chunk-ea83b9dc":"10853ba5","chunk-96165c04":"861435fd","chunk-0803eb98":"c535274d","chunk-21148dc0":"ab881ab0","chunk-29ee2f46":"07e258fe","chunk-35e0a236":"48df5da6","chunk-485b326e":"da6f35eb","chunk-1fe9e53e":"5e391891","chunk-4976f42e":"754bca12","chunk-5cd8b1b2":"0155b02d","chunk-7a53ded0":"7ee721e1","chunk-91e5b5a2":"856532c2","chunk-c082a7c2":"32fb065a","chunk-c8e13774":"cbd41a13","chunk-e00e80a6":"b9a83873","chunk-eef7d4f4":"120c67ea","chunk-3c6db8a0":"25c61672","chunk-653fb15b":"4c465c9a","chunk-5f852da0":"4d4968bf","chunk-c459b00a":"8362ffa8","lang-en-js":"50cf56d4","lang-zh-js":"42f31f4d","chunk-2d0abc5c":"a6bfce72","chunk-2d0e4e90":"a8370d4f","chunk-2d0e64ab":"7c1da667","chunk-6d99fabf":"cb298305","chunk-3d3ad39a":"52b0c426","chunk-4ac242e5":"4ec57c6c","chunk-e2ab2448":"9abd12c8","chunk-3d982fba":"7a81e71f","chunk-2ad9e8d8":"c7fe3c6e","chunk-2db87d01":"83cd0b56","chunk-5e0c72c5":"e0f7167a","chunk-d52e6dc6":"bae8fcf3","chunk-fac69c6a":"9a19f4b9","chunk-2d207bc1":"a577a12a","chunk-71ae5878":"0983903f","chunk-95a8b3e0":"d0fcd963","chunk-230ea515":"55687b6f","chunk-3e800c08":"d1ba3739","chunk-64f0d273":"5c1cbbbf","chunk-2b67225a":"9a9eb62c","chunk-642877cc":"941beb1e","chunk-0efc5449":"102df136","chunk-27df7e55":"ae817ca9","chunk-277db424":"b3332064","chunk-2b2de04c":"ec88f787","chunk-93c91efe":"7322648d","chunk-faeb8ace":"970b1787"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0d76e780":1,"chunk-4d349a64":1,"chunk-494d09ee":1,"chunk-38960fdc":1,"chunk-3ce489d0":1,"chunk-e35cdb6a":1,"chunk-541fe940":1,"chunk-96165c04":1,"chunk-0803eb98":1,"chunk-21148dc0":1,"chunk-29ee2f46":1,"chunk-35e0a236":1,"chunk-485b326e":1,"chunk-1fe9e53e":1,"chunk-4976f42e":1,"chunk-5cd8b1b2":1,"chunk-7a53ded0":1,"chunk-91e5b5a2":1,"chunk-c082a7c2":1,"chunk-c8e13774":1,"chunk-e00e80a6":1,"chunk-eef7d4f4":1,"chunk-3c6db8a0":1,"chunk-653fb15b":1,"chunk-5f852da0":1,"chunk-c459b00a":1,"chunk-6d99fabf":1,"chunk-3d3ad39a":1,"chunk-4ac242e5":1,"chunk-e2ab2448":1,"chunk-3d982fba":1,"chunk-2ad9e8d8":1,"chunk-2db87d01":1,"chunk-5e0c72c5":1,"chunk-d52e6dc6":1,"chunk-fac69c6a":1,"chunk-71ae5878":1,"chunk-95a8b3e0":1,"chunk-230ea515":1,"chunk-3e800c08":1,"chunk-64f0d273":1,"chunk-2b67225a":1,"chunk-642877cc":1,"chunk-0efc5449":1,"chunk-27df7e55":1,"chunk-277db424":1,"chunk-2b2de04c":1,"chunk-93c91efe":1,"chunk-faeb8ace":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en-js":"lang-en-js","lang-zh-js":"lang-zh-js"}[chunkId]||chunkId) + "." + {"chunk-0c585b89":"31d6cfe0","chunk-030f5245":"31d6cfe0","chunk-0d76e780":"cda80fb2","chunk-4c058107":"31d6cfe0","chunk-4d349a64":"08d86cdb","chunk-494d09ee":"9d3ca11f","chunk-2d238065":"31d6cfe0","chunk-38960fdc":"cbf37e2b","chunk-3ce489d0":"08f34299","chunk-488c6ca2":"31d6cfe0","chunk-e35cdb6a":"34a85172","chunk-541fe940":"88373b00","chunk-e8063f78":"31d6cfe0","chunk-ea83b9dc":"31d6cfe0","chunk-96165c04":"fdff7af9","chunk-0803eb98":"a9393d97","chunk-21148dc0":"eaef2b6e","chunk-29ee2f46":"a82cd54b","chunk-35e0a236":"366b5f6a","chunk-485b326e":"e0984c9b","chunk-1fe9e53e":"e89e16bd","chunk-4976f42e":"050bf416","chunk-5cd8b1b2":"3d6b2511","chunk-7a53ded0":"448d3d44","chunk-91e5b5a2":"b5f36b38","chunk-c082a7c2":"0983f2f4","chunk-c8e13774":"e823b47e","chunk-e00e80a6":"61e37a4c","chunk-eef7d4f4":"e823b47e","chunk-3c6db8a0":"5417f904","chunk-653fb15b":"3966ff8c","chunk-5f852da0":"dd1a2e36","chunk-c459b00a":"45b1f5ab","lang-en-js":"31d6cfe0","lang-zh-js":"31d6cfe0","chunk-2d0abc5c":"31d6cfe0","chunk-2d0e4e90":"31d6cfe0","chunk-2d0e64ab":"31d6cfe0","chunk-6d99fabf":"65787afa","chunk-3d3ad39a":"5944b1ba","chunk-4ac242e5":"36d34506","chunk-e2ab2448":"65787afa","chunk-3d982fba":"864a494c","chunk-2ad9e8d8":"a3159be3","chunk-2db87d01":"efe9df9a","chunk-5e0c72c5":"94f48e8c","chunk-d52e6dc6":"ab9211b5","chunk-fac69c6a":"7ab2394b","chunk-2d207bc1":"31d6cfe0","chunk-71ae5878":"8c0c2afb","chunk-95a8b3e0":"d048b279","chunk-230ea515":"b2363eeb","chunk-3e800c08":"65787afa","chunk-64f0d273":"65787afa","chunk-2b67225a":"5c313be9","chunk-642877cc":"e29388e7","chunk-0efc5449":"2ec39b73","chunk-27df7e55":"46d0384f","chunk-277db424":"bfd002ef","chunk-2b2de04c":"2c21af17","chunk-93c91efe":"9fe8b94d","chunk-faeb8ace":"28f4d078"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://xl-act2-static.xiaolachuxing.com/page/202105/act_tpl_hub/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
